export default {
    COLESTEROL_TOTAL: 1,
    CREATININA: 2,
    EAS_EQU: 3,
    ELETROCARDIOGRAMA: 4,
    ELETROFORESE_DE_HEMOGLOBINA: 5,
    ESPIROMETRIA: 6,
    EXAME_DE_ESCARRO: 7,
    GLICEMIA: 8,
    HDL: 9,
    HEMOGLOBINA_GLICADA: 10,
    HEMOGRAMA: 11,
    LDL: 12,
    RETINOGRAFIA_FUNDO_DE_OLHO_COM_OFTALMOLOGISTA: 13,
    SOROLOGIA_DE_SIFILIS: 14,
    SOROLOGIA_PARA_DENGUE: 15,
    SOROLOGIA_PARA_HIV: 16,
    TESTE_INDIRETO_DE_ANTIGLOBULINA_HUMANA: 17,
    TESTE_DE_GRAVIDEZ: 18,
    ULTRASSONOGRAFIA_OBSTETRICA: 19,
    UROCULTURA: 20,
    ANTIBIOGRAMA: 21,
    HEPATITE_B: 22,
    HEPATITE_C: 23,
    FATOR_RH: 24,
    GRUPO_ABO: 25,
}




